import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-percentage',
  templateUrl: './progress-percentage.component.html',
  styles: ``
})
export class ProgressPercentageComponent {
  @Input() title!: string;
  @Input() value!: number;
  @Input() color!: string;
  @Input() isNumber: boolean = false;
  @Input() number: number = 100;
}
